const BordersFoundationsThemes = {
    border_00: '0rem',
    border_25: '0.03125rem',
    border_50: '0.0625rem',
    border_75: '0.09375rem',
    border_100: '0.125rem',
    border_125: '0.1875rem',
    border_150: '0.25rem',
    border_200: '0.125rem',
};
export { BordersFoundationsThemes };
//# sourceMappingURL=borders-foundations.themes.js.map